<div class="row spacing-20">
  <div class="d-flex flex-wrap flex-stack mb-6">
    <h3 class="fw-bold my-2">Membership Plans</h3>
    <div class="d-flex flex-wrap my-2">
      <app-button
        [variant]="'primary'"
        [label]="'Add Plan'"
        [iconClass]="'fa fa-plus'"
        (clicked)="openAddPlanModal()"
      />
    </div>
  </div>

  @if (loading) {
    <div class="card">
      <div class="card-body text-center py-10">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  } @else {
    @if (plans.length === 0) {
      <div class="card">
        <div class="card-body text-center py-10">
          <i class="fa fa-receipt fs-3x text-muted mb-4"></i>
          <h4 class="text-muted">No membership plans yet</h4>
          <p class="text-muted">Create your first membership plan to get started</p>
        </div>
      </div>
    } @else {
      <div class="row g-6 g-xl-9">
        @for (plan of plans; track plan.plan_id) {
          <div class="col-md-6 col-xl-4">
            <div class="card h-100">
              <div class="card-header border-0 pt-9">
                <div class="card-title m-0">
                  <div class="symbol symbol-50px w-50px bg-light">
                    <i class="fa fa-receipt fs-2x text-primary"></i>
                  </div>
                </div>
                <div class="card-toolbar">
                  <button class="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" type="button" data-bs-toggle="dropdown">
                    <i class="fa fa-ellipsis-v d-flex align-items-center justify-content-center" style="line-height: 1;"></i>
                  </button>
                  <div class="dropdown-menu dropdown-menu-end">
                    <a class="dropdown-item" (click)="openEditPlanModal(plan)">
                      <i class="fa fa-edit me-2"></i>Edit
                    </a>
                    <a class="dropdown-item text-danger" (click)="deletePlan(plan)">
                      <i class="fa fa-trash me-2"></i>Delete
                    </a>
                  </div>
                </div>
              </div>

              <div class="card-body p-9">
                <div class="fs-3 fw-bold text-gray-900">{{ plan.name }}</div>
                <p class="text-gray-500 fw-semibold fs-5 mt-1 mb-7">{{ plan.code }}</p>

                <div class="d-flex flex-wrap mb-5">
                  <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-7 mb-3">
                    <div class="fs-6 text-gray-800 fw-bold">{{ formatPrice(plan.price_cents) }} kr</div>
                    <div class="fw-semibold text-gray-500">Price</div>
                  </div>
                  <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 mb-3">
                    <div class="fs-6 text-gray-800 fw-bold">{{ plan.billing_cycle | titlecase }}</div>
                    <div class="fw-semibold text-gray-500">Billing</div>
                  </div>
                </div>

                <div class="mb-5">
                  <span class="badge" [class.badge-primary]="plan.coverage === 'individual'" [class.badge-success]="plan.coverage === 'family'">
                    {{ plan.coverage | titlecase }}
                  </span>
                  @if (plan.max_children) {
                    <span class="badge badge-secondary ms-2">Max {{ plan.max_children }} children</span>
                  }
                </div>

                <div class="d-flex flex-stack">
                  <div class="text-muted fw-semibold fs-7">
                    Created: {{ plan.created_at | date:'shortDate' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
  }
</div>
